<div class="d-flex flex-column flex-root">
  <div
    class="login login-4 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
    id="kt_login"
  >
    <!--begin::Content-->
    <div
      class="order-2 order-lg-1 flex-column-auto flex-lg-row-fluid d-flex flex-column p-7 login-contentside"
    >
      <!--begin::Content body-->

      <!-- <div  class="d-flex flex-column-fluid flex-lg-center">
        <school-homeaside></school-homeaside>
      </div> -->
      <!--end::Content body-->
    </div>
    <!--end::Content-->
    <!--begin::Aside-->
    <div
      class="login-aside order-1 order-lg-2 d-flex flex-column-fluid flex-lg-row-auto bgi-size-cover bgi-no-repeat"
    >
      <!--begin: Aside Container-->

      <div
        class="d-flex flex-row-fluid flex-column justify-content-between"

      >
        <perfect-scrollbar
          [config]="{
            wheelSpeed: 0.5,
            swipeEasing: true,
            suppressScrollY: false,
            suppressScrollX: true,
            minScrollbarLength: 1,
            maxScrollbarLength: 300
          }"
        >
          <!--begin::Aside body-->
          <div class="d-flex flex-column-fluid flex-column mt-10 mt-lg-0 ">
       <a href="#" class="mb-10 flex justify-center login-logo mt-10">
  <img class="img-fluid  w-50 h-50" alt="" [attr.src]="logopath" />
</a>
            <div class="border-top width100p">&nbsp;</div>
            <!--begin::Signin-->

            <router-outlet></router-outlet>
          </div>
          <!--end::Aside body-->
          <!--begin: Aside footer for desktop-->
          <div class="d-flex flex-column-auto justify-content-between  p-10">
            <div class="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              © {{ copyyear }} Maven Healthcare Consulting Inc.
            </div>
            <div class="d-flex order-1 order-sm-2 my-2">
              <span class=" text-dark-50">Version: {{appVersion}}</span>
              <!-- <a href="#" class="text-muted text-hover-primary">Privacy</a>
              <a href="#" class="text-muted text-hover-primary ml-4">Legal</a>
              <a href="#" class="text-muted text-hover-primary ml-4">Contact</a> -->
            </div>
          </div>
          <!--end: Aside footer for desktop-->
        </perfect-scrollbar>
      </div>
      <!--end: Aside Container-->
    </div>
  </div>
</div>
